import { IncomeOverrideActivity } from "../types";
import { RoleTitles } from "views/settings-users/slices/users/constants";
import { getFullName } from "shared/utils/get-full-name";

export const IncomeOverride = ({
  activity
}: {
  activity: IncomeOverrideActivity;
}) => {
  const author = activity.author?.name ?? activity.author?.email;
  const authorRole: string =
    RoleTitles[activity.author?.author_role ?? ""] ?? "";
  return (
    <div>
      <p>
        <span className="font-bold">Income verification overridden</span>
        {author && ` by ${author} `}
        {authorRole && ` (${authorRole})`}
      </p>
      <p className="text-sm text-content-400 mt-2">
        For{" "}
        {getFullName({
          firstName: activity.details.contact.first_name,
          lastName: activity.details.contact.last_name,
          middleName: activity.details.contact.middle_name,
          short: true
        })}
        {activity.details.income?.name &&
          ` • Income source: ${activity.details.income.name}`}
      </p>
    </div>
  );
};
